import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/lib/auth";

/**
 * True when the signed-in user belongs to at least one active Contractor
 * Partner relationship. Used for navigation placement only — RLS on
 * `contractor_members` is what actually restricts the read.
 */
export function useContractorMembership(): boolean {
  const { user } = useAuth();
  const { data } = useQuery({
    queryKey: ["contractor-membership", user?.id ?? "anon"],
    enabled: Boolean(user?.id),
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("contractor_members")
        .select("id")
        .eq("user_id", user!.id)
        .eq("active", true)
        .limit(1);
      if (error) return false;
      return (data ?? []).length > 0;
    },
  });
  return Boolean(data);
}
